module.exports = __webpack_public_path__ + "img/隐式安装读卡器 (5).bc6eaded.jpg";